import { useState, useEffect } from "react";
import {
    Typography,
    Card,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Backdrop,
    CircularProgress,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Autocomplete,
    Box
} from "@mui/material";
import { cardHeader, textStyle, headerStyle, subHeaderStyle, card_icon } from "../../styles/sharedStyles";
import { fetchAPI } from "../../utils/ApiService";
import Plot from 'react-plotly.js';
import { CustomizedSnackbar } from "../../utils/CustomizedSnackbar";
import DeleteIcon from '@mui/icons-material/Delete'
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AirIcon from '@mui/icons-material/Air';
import AllOutIcon from '@mui/icons-material/AllOut';
import ArticleIcon from '@mui/icons-material/Article';
import CycloneIcon from '@mui/icons-material/Cyclone';


const cardStyle = {
    marginTop: "12px",
    padding: "20px",
    borderRadius: "20px",
    border: "0px",
}


export const Optimization = () => {

    const objectiveTypes = [
        "Maximize",
        "Minimize",
    ];

    const constraintTypes = [
        "<",
        "<=",
        ">",
        ">=",
        "=",
    ];

    const geometryconstraintTypes = [...constraintTypes, 'None'];
    const [problemFormulation, setProblemFormulation] = useState("");
    const [geometryInputs, setGeometryInputs] = useState([]);
    const [boundaryCondition, setBoundaryCondition] = useState("");
    const [outputVariables, setoutputVariables] = useState([]);
    const [loadopen, setLoadpen] = useState(false);
    const [problemFormulationList, setProblemFormulationList] = useState([]);
    const [selectedOutputVariableObjective, setSelectedOutputVariableObjective] = useState("");
    const [selectedOutputVariableConstraint, setSelectedOutputVariableConstraint] = useState("");
    const [constraintValue, setConstraintValue] = useState("");
    const [boundaryConstraintValue, setBoundaryConstraintValue] = useState("");
    const [objectiveSurroagteModel, setObjectiveSurroagteModel] = useState("");
    const [constraintSurroagteModel, setConstraintSurroagteModel] = useState("");
    const [surrogateModels, setSurrogateModels] = useState([]);
    const [inputConstraints, setInputConstraints] = useState('');
    const [outputConstraints, setOutputConstraints] = useState('');
    const [optImg1plotData, setOptImg1plotData] = useState(null);
    const [optImg2plotData, setOptImg2plotData] = useState(null);
    const [figHistogram, setFigHistogram] = useState(null);
    const [optimizationTable, setOptimizationTable] = useState(null);
    const [optimizationStatus, setOptimizationStatus] = useState(null);
    const [objectiveSurrogateModels, setObjectiveSurrogateModels] = useState([]);
    const [objectiveConstraintModels, setObjectiveConstraintModels] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [severityType, setSeverityType] = useState("");
    const objectiveTypeList = objectiveTypes;
    const constraintTypeList = constraintTypes;
    const [objectiveType, setObjectiveType] = useState("");
    const [constraintType, setConstraintType] = useState("");
    const [boundaryconstraintType, setBoundaryConstraintType] = useState("");

    const [geometryInputConstraints, setgeometryInputConstraints] = useState({});
    const [geometryInputProcessConstraints, setgeometryInputProcessConstraints] = useState([]);
    const [geometryInputInvalidProcessConstraints, setgeometryInputInvalidProcessConstraints] = useState([]);
    const [error, setError] = useState("");
    const [boundaryError, setBoundaryError] = useState("");
    const [errors, setErrors] = useState({});

    useEffect(() => {
        getProblemList();
    }, [])

    useEffect(() => {
        setgeometryInputConstraints(Object.fromEntries(geometryInputs.map((item, index) => [item, { 'type': 'None', 'value': '' }])));
    }, [geometryInputs])


    const buttonStyle = {
        padding: "6px 24px",
        borderRadius: "8px",
        fontSize: "large",
        fontWeight: "bold",
        backgroundColor: "#2a2aa8"
    }


    const getProblemList = async () => {
        try {
            setLoadpen(true);
            const token = localStorage.getItem("msal.idtoken");
            const { data: { data: problemList } } = await fetchAPI.get("/get_problem_formulation_list", {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            setProblemFormulationList(problemList);
            setLoadpen(false);
        } catch (error) {
            setLoadpen(false);
            console.error("Failed to fetch problem list:", error);
        }
    };

    const handleProblemFormulationChange = (event, newValue) => {
        setProblemFormulation(newValue || "");
        if (newValue) {
            getMetaData(newValue);
        }
    };

    const getMetaData = async (problemName) => {
        setLoadpen(true);

        try {
            const token = localStorage.getItem("msal.idtoken");
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            };

            // Call both APIs in parallel
            const [problemRes, surrogateRes] = await Promise.all([
                fetchAPI.post("/get_meta_data", { problemName }, { headers }),
                fetchAPI.post("/get_surrogate_list", { problemName }, { headers }),
            ]);

            const problemData = problemRes?.data?.data;
            const surrogateList = surrogateRes?.data?.data;

            // Update state with response data
            setGeometryInputs(problemData?.inputs || []);
            setBoundaryCondition(problemData?.loaded_boundary || []);
            setoutputVariables(problemData?.output_variables || []);
            setSurrogateModels(surrogateList || []);
            setInputConstraints(JSON.stringify(problemData?.constraints?.input) || "[ ]");
            setOutputConstraints(JSON.stringify(problemData?.constraints?.output) || "[ ]");
            setgeometryInputConstraints(Object.fromEntries(problemData?.inputs.map((item, index) => [item, { 'type': '', 'value': '' }])));
            clearData();
        } catch (error) {
            console.error("Failed to fetch metadata:", error);
        } finally {
            setLoadpen(false);
        }
    };

    const clearData = () => {
        setSelectedOutputVariableObjective('');
        setSelectedOutputVariableConstraint('');
        setBoundaryConstraintValue('');
        setObjectiveSurroagteModel('');
        setConstraintSurroagteModel('');
        setObjectiveType();
        setBoundaryConstraintType('');
        setConstraintType('');
        setgeometryInputProcessConstraints([]);
        setConstraintValue('');
        setOptImg1plotData(null);
        setOptImg2plotData(null);
        setFigHistogram(null);
        setOptimizationTable(null);
        setOptimizationStatus(null);
        setObjectiveSurrogateModels([]);
        setObjectiveConstraintModels([]);

    }

    const checkOptimizationButton =
        problemFormulation &&
        geometryInputs.length > 0 &&
        boundaryCondition &&
        objectiveSurroagteModel &&
        constraintSurroagteModel &&
        boundaryConstraintValue &&
        constraintValue &&
        objectiveType &&
        boundaryconstraintType &&
        geometryInputInvalidProcessConstraints.length === 0 &&
        !boundaryError &&
        !error

    const runOptimization = async () => {
        try {
            setLoadpen(true);

            setSnackbarOpen(false)

            const payload = {
                ptsModels: constraintSurroagteModel,
                etaModels: objectiveSurroagteModel,
                ptsInput: constraintValue,
                qcfmInput: boundaryConstraintValue,
                loadedInputs: "['" + geometryInputs.join("','") + "']",
                loadedBoundary: boundaryCondition,
                problemFormulation: problemFormulation,
                constraintType: constraintType,
                boundaryconstraintType: boundaryconstraintType,
                objectiveType: objectiveType,
                geometryInputConstraints: geometryInputProcessConstraints.join('\n')
            }

            // df will download in backend
            const token = localStorage.getItem("msal.idtoken");
            const response = await fetchAPI.post("/run_optimization", payload, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 202 || response.status === 200) {

                const checkUploadStatus = async () => {

                    try {
                        const statusResponse = await fetchAPI.post("/upload_stats_optimization", { problemFormulation }, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });

                        if (statusResponse.status === 200) {
                            if (statusResponse?.data?.data?.error) {
                                console.log(statusResponse.data.data.message)
                                setSnackbarMsg(statusResponse.data.data.message)
                                setSeverityType("warning")
                                setOptImg1plotData(null);
                                setOptImg2plotData(null);
                                setFigHistogram(null);
                                setOptimizationTable(null);
                                setOptimizationStatus(null);


                            } else {
                                setSnackbarMsg("Optimization successfully completed")
                                setSeverityType("success")
                                setOptImg1plotData(statusResponse?.data?.data?.optimization_Img1 ?? null);
                                setOptImg2plotData(statusResponse?.data?.data?.optimization_Img2 ?? null);
                                setFigHistogram(statusResponse?.data?.data?.fig_histogram ?? null);
                                setOptimizationTable(statusResponse?.data?.data?.table ? JSON.parse(statusResponse?.data?.data?.table)[0] : null);
                                setOptimizationStatus(statusResponse?.data?.data?.optimization_status ?? null);
                            }
                            setLoadpen(false)
                            setSnackbarOpen(true)



                        }
                        else {
                            console.log('Waiting for upload status to complete...');
                            setTimeout(checkUploadStatus, 5000);
                        }

                    } catch (error) {
                        const errorMessage = error.response?.data?.message || 'Something went wrong';
                        console.error(errorMessage);
                        setLoadpen(false)
                        setSnackbarMsg(errorMessage)
                        setSeverityType("error")
                        setSnackbarOpen(true)

                    }

                };
                checkUploadStatus();

            } else {
                setLoadpen(false)
                setSnackbarMsg('Error: Unable to complete Optimization')
                setSnackbarOpen(true)
                throw new Error('Error in Optimizing the model');
                // setTimeout(checkUploadStatus, 2000);
            }

            // console.log('data :>> ', data);
            // console.log('status :>> ', status);

            // if (data?.error_msg) {
            //     setSnackbarMsg(data?.error_msg);
            //     setSeverityType("error");
            //     setSnackbarOpen(true);

            //     setOptImg1plotData(null);
            //     setOptImg2plotData(null);
            //     setFigHistogram(null);
            //     setOptimizationTable(null);
            //     setOptimizationStatus(null);


            // }

            // else {
            //     setOptImg1plotData(data?.optimization_Img1 ?? null);
            //     setOptImg2plotData(data?.optimization_Img2 ?? null);
            //     setFigHistogram(data?.fig_histogram ?? null);
            //     setOptimizationTable(data?.table[0] ?? null);
            //     setOptimizationStatus(data?.optimization_status ?? null);
            // }




            // setProblemFormulationList(problemList);
            // setLoadpen(false);
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to Run Optimization';
            console.log("status code : ", error.response?.data?.status)
            console.log(errorMessage)
            setLoadpen(false)
            setSnackbarMsg(errorMessage)
            setSeverityType("error")
            setSnackbarOpen(true)
        }
    }

    const handleGeometryInputConstraintKey = (rowIndex, key_value) => {
        const keys = Object.keys(geometryInputConstraints);
        if (keys.length > 0) {
            const lastKey = keys[keys.length - 1];
            const { [lastKey]: removedValue, ...restOfData } = geometryInputConstraints;
            restOfData[key_value] = removedValue
            setgeometryInputConstraints(restOfData);
        }
    }

    // const handleGeometryInputConstraintType = (input, value) => {
    //     const updatedData = { ...geometryInputConstraints };
    //     updatedData[input]['type'] = value;
    //     setgeometryInputConstraints(updatedData);
    // }

    // const handleGeometryInputConstraintValue = (input, value) => {
    //     const updatedData = { ...geometryInputConstraints };
    //     // if(geometryInputConstraints[input] != '=' && typeof(value) === Number){
    //     updatedData[input]['value'] = value
    //     // }
    //     // else {
    //     //     updatedData[input]['min'] = value['min'];
    //     //     updatedData[input]['max'] = value['max'];
    //     // }
    //     setgeometryInputConstraints(updatedData);

    // }


    const validateEqualConstraintValue = (value) => {
        const regex = /^\[\s*[+-]?\d+(\.\d+)?\s*,\s*[+-]?\d+(\.\d+)?\s*\]$/;
        return regex.test(value);
    };

    const handleGeometryInputConstraintType = (input, value) => {
        const updatedData = { ...geometryInputConstraints };
        updatedData[input] = { ...updatedData[input], type: value };

        // Clear error or validate based on new type
        if (value === "=") {
            if (!validateEqualConstraintValue(updatedData[input].value)) {
                setErrors((prev) => ({
                    ...prev,
                    [input]: "Value must be in format [min, max]",
                }));
            } else {
                setErrors((prev) => ({ ...prev, [input]: "" }));
            }
        } else {
            // Clear error for other types
            setErrors((prev) => ({ ...prev, [input]: "" }));
        }

        setgeometryInputConstraints(updatedData);
    };

    const handleGeometryInputConstraintValue = (input, value) => {
        const updatedData = { ...geometryInputConstraints };
        updatedData[input] = { ...updatedData[input], value };

        // Validate only if type is '='
        if (updatedData[input].type === "=") {
            if (!validateEqualConstraintValue(value)) {
                setErrors((prev) => ({
                    ...prev,
                    [input]: "Value must be in format [min, max]",
                }));
            } else {
                setErrors((prev) => ({ ...prev, [input]: "" }));
            }
        } else {
            // Clear error for other types
            setErrors((prev) => ({ ...prev, [input]: "" }));
        }

        setgeometryInputConstraints(updatedData);
    };

    const checkgeometryInputIsEmpty = () => {
        const filteredEntries = Object.entries(geometryInputConstraints).filter(([key, value]) => key === '');
        return filteredEntries.length > 0 ? true : false;
    }
    const deleteRow = (input) => {
        // const updatedData = {...geometryInputConstraints};
        // delete geometryInputConstraints[input];
        const constraintValues = Object.assign({}, geometryInputConstraints)
        delete constraintValues[input]
        setgeometryInputConstraints(constraintValues);
    };
    const addNewRow = () => {
        const constraintValues = Object.assign({}, geometryInputConstraints)
        constraintValues[''] = { 'type': '', 'value': '' }
        setgeometryInputConstraints(constraintValues);
    };

    const processConstraints = async () => {
        try {
            const statusResponse = await fetchAPI.post("/process_geometry_input_constraints", { geometryInputConstraints }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });
            if (statusResponse.status === 200) {
                if (statusResponse?.data?.data?.error) {
                    console.log(statusResponse.data.data.message)
                } else {
                    setgeometryInputProcessConstraints(statusResponse?.data?.data ? statusResponse.data.data : null);
                    setgeometryInputInvalidProcessConstraints(statusResponse?.data?.data ? statusResponse.data.invalid_data : null);
                }
            }
            else {
                console.log('Waiting for upload status to complete...');
                //setTimeout(checkUploadStatus, 5000);
            }

        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Something went wrong';
            console.error(errorMessage);
        }
    };

    const solutionTable = () => {
        const keys = Object.keys(optimizationTable)
        const values = Object.values(optimizationTable)

        return (
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {keys.map((key) => (
                                <TableCell key={key}><strong>{key}</strong></TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {values.map((value, index) => (
                                <TableCell key={index}>{value}</TableCell>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    const handleConstraintValueChange = (e) => {
        const value = e.target.value;
        setConstraintValue(value);

        if (constraintType === "=") {
            // Regex for format: [number,number]
            const regex = /^\[\s*[+-]?\d+(\.\d+)?\s*,\s*[+-]?\d+(\.\d+)?\s*\]$/;
            if (!regex.test(value)) {
                setError("Format must be [min,max], e.g. [1,2]");
            } else {
                setError("");
            }
        } else {
            setError("");
        }
    };

    const handleBoundaryConstraintValueChange = (e) => {
        const value = e.target.value;
        setBoundaryConstraintValue(value);

        if (boundaryconstraintType === "=") {
            // Regex for format: [number,number]
            const regex = /^\[\s*[+-]?\d+(\.\d+)?\s*,\s*[+-]?\d+(\.\d+)?\s*\]$/;
            if (!regex.test(value)) {
                setBoundaryError("Format must be [min,max], e.g. [1,2]");
            } else {
                // extra validation: num1 < num2
                // const [num1, num2] = value
                //     .replace(/\[|\]/g, "")
                //     .split(",")
                //     .map(v => Number(v.trim()));
                // if (num1 >= num2) {
                //     setBoundaryError("First number must be less than second number");
                // } else {
                //     setBoundaryError("");
                // }
                setBoundaryError("");
            }
        } else {
            setBoundaryError("");
        }
    };

    return (
        <>
            <Typography
                variant="h5"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "rgb(27 37 75)",
                    fontFamily: "DM Sans, sans-serif",
                    fontSize: "24px",
                }}
            >
                Optimization
            </Typography>

            <Card variant="outlined" sx={cardStyle}>
                <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={[cardHeader, { marginBottom: "0px", }]}>Select a problem formulation</Typography>
                </Grid>
                <Grid container spacing={4} sx={{ mb: 3 }}>
                    <Grid size={12}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <Autocomplete
                                id="problem-formulation-autocomplete"
                                options={problemFormulationList || []}
                                value={problemFormulation || null}
                                onChange={handleProblemFormulationChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select problem formulation"
                                        variant="outlined"
                                        placeholder="Search problem formulation"
                                    />
                                )}
                                filterOptions={(options, { inputValue }) => {
                                    return options.filter(option =>
                                        option.toLowerCase().includes(inputValue.toLowerCase())
                                    );
                                }}
                                isOptionEqualToValue={(option, value) => option === value}
                                clearOnEscape
                                selectOnFocus
                                handleHomeEndKeys
                            />
                        </FormControl>

                    </Grid>
                </Grid>

                {(geometryInputs.length > 0 || boundaryCondition || outputVariables.length > 0) ? (
                    <Box
                        display="flex"
                        flexWrap="wrap"
                        gap={2}
                        justifyContent="space-between"
                    >
                        <Card
                            sx={{
                                // mt: 1,
                                flex: '1 1 calc(45% - 8px)',
                                minWidth: 300,
                                // p: 1,
                                padding: "15px",
                                height: (geometryInputs.length > 0 || boundaryCondition || outputVariables.length > 0) ? 205 : 'fit-content',
                                maxHeight: 205,
                                overflow: 'auto',
                                border: "none",
                                boxShadow: "0 1px 8px #d1dcf9",
                                borderRadius: "14px"
                            }}
                            variant="outlined"
                        >
                            <Typography fontWeight="fontWeightBold" sx={[{ mb: 2 }, headerStyle]}>Problem formulation details</Typography>


                            <>
                                {geometryInputs.length > 0 && (
                                    <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                        <AirIcon sx={[card_icon, { color: "#008cff" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Geometry Inputs: </span>

                                        <span style={textStyle}> {geometryInputs.join(',  ')}</span>
                                    </Typography>
                                )}

                                {boundaryCondition && (
                                    <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                        <AnalyticsIcon sx={[card_icon, { color: "#e59128" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Boundary Condition: </span>

                                        <span style={textStyle}> {boundaryCondition}</span>
                                    </Typography>
                                )}

                                {outputVariables.length > 0 && (
                                    <Typography sx={[subHeaderStyle, { margin: "8px 0px" }]}>
                                        <CycloneIcon sx={[card_icon, { color: "#1daa07" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Output Variables: </span>

                                        <span style={textStyle}> {outputVariables.join(', ')}</span>
                                    </Typography>
                                )}
                            </>

                        </Card>

                        <Card
                            sx={{
                                // mt: 1,
                                flex: '1 1 calc(55% - 8px)',
                                minWidth: 300,
                                // p: 1,
                                padding: "15px",
                                height: ((inputConstraints && inputConstraints !== '[ ]') || (outputConstraints && outputConstraints !== '[ ]')) ? 205 : 'fit-content',
                                maxHeight: 205,
                                overflow: 'auto',
                                border: "none",
                                boxShadow: "0 1px 8px #d1dcf9",
                                borderRadius: "14px"
                            }}
                            variant="outlined"
                        >
                            <Typography sx={[headerStyle, { marginBottom: "8px" }]}>Constraints</Typography>


                            <>
                                {inputConstraints && inputConstraints !== '[ ]' && (
                                    <Typography sx={[subHeaderStyle,]}>
                                        <ArticleIcon sx={[card_icon, { color: "#e0ae14" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Input Constraints: </span>

                                        <span style={textStyle}> {inputConstraints}</span>
                                    </Typography>
                                )}

                                {outputConstraints && outputConstraints !== '[ ]' && (
                                    <Typography sx={subHeaderStyle}>
                                        <ArticleIcon sx={[card_icon, { color: "#e0ae14" }]} />
                                        <span style={{ whiteSpace: "nowrap", margin: "0px 5px" }}>Output Constraints: </span>

                                        <span style={textStyle}> {outputConstraints}</span>
                                    </Typography>
                                )}
                            </>

                        </Card>
                    </Box>) : null}

            </Card>


            <Card variant="outlined" sx={cardStyle}>

                <Typography
                    variant="p"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                    }}
                >
                    Objective function:
                </Typography>

                <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid size={4}>

                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="problem-formulation">
                                Select output variable
                            </InputLabel>
                            <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                value={selectedOutputVariableObjective}
                                label="Select output variable"
                                onChange={(e) => {
                                    if (e.target.value === selectedOutputVariableConstraint) {
                                        setSelectedOutputVariableConstraint('');
                                        setObjectiveSurrogateModels([])
                                    }
                                    setSelectedOutputVariableObjective(e.target.value)
                                    const filtered = surrogateModels.filter(option =>
                                        option.toLowerCase().includes(e.target.value.toLowerCase())
                                    );
                                    setObjectiveSurrogateModels(filtered)
                                }}
                            >
                                {outputVariables?.map((outputVariable, index) => {
                                    return (
                                        <MenuItem value={outputVariable} key={index}>
                                            {outputVariable}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={4}>

                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="problem-formulation">
                                Select the surrogate model for objective function
                            </InputLabel>
                            <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                value={objectiveSurroagteModel}
                                label="Select the surrogate model for objective function"
                                onChange={(e) => {
                                    setObjectiveSurroagteModel(e.target.value)
                                }}
                            >
                                {objectiveSurrogateModels?.map((outputVariable) => {
                                    return (
                                        <MenuItem value={outputVariable}>
                                            {outputVariable}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={4}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="objective-type">
                                Objective type
                            </InputLabel>
                            <Select
                                labelId="objective-type"
                                id="demo-simple-select"
                                value={objectiveType}
                                label="Objective type"
                                onChange={(e) => {
                                    setObjectiveType(e.target.value)
                                }}
                            >
                                {objectiveTypeList.map((kernel) => (
                                    <MenuItem key={kernel} value={kernel}>
                                        {kernel}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                </Grid>

            </Card>
            {/* <Typography
                    variant="p"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                    }}
                >
                    Constraints:
                </Typography> */}

            <Card variant="outlined" sx={cardStyle}>
                <Typography
                    variant="p"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                    }}
                >
                    Constraints:
                </Typography>

                <Grid container spacing={4} sx={{ mb: 3 }}>
                    <Grid size={3}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="problem-formulation">
                                Select output variable
                            </InputLabel>
                            <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                value={selectedOutputVariableConstraint}
                                label="Select output variable"
                                onChange={(e) => {
                                    if (e.target.value === selectedOutputVariableObjective) {
                                        setSelectedOutputVariableObjective(''); // reset first select if duplicate
                                        setObjectiveConstraintModels([])
                                    }
                                    setSelectedOutputVariableConstraint(e.target.value)
                                    const filtered = surrogateModels.filter(option =>
                                        option.toLowerCase().includes(e.target.value.toLowerCase())
                                    );
                                    console.log(filtered)
                                    setObjectiveConstraintModels(filtered);
                                }}
                            >
                                {outputVariables?.map((outputVariable, index) => {
                                    return (
                                        <MenuItem value={outputVariable} key={index}>
                                            {outputVariable}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={3}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="problem-formulation">
                                Select surrogate for constraint
                            </InputLabel>
                            <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                value={constraintSurroagteModel}
                                label="Select surrogate for constraint"
                                onChange={(e) => {
                                    setConstraintSurroagteModel(e.target.value)
                                }}

                            >
                                {objectiveConstraintModels?.map((outputVariable) => {
                                    return (
                                        <MenuItem value={outputVariable}>
                                            {outputVariable}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={3}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="problem-formulation">
                                Constraint type
                            </InputLabel>
                            <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                value={constraintType}
                                label="Constraint type"
                                onChange={(e) => {
                                    setConstraintType(e.target.value);
                                    setConstraintValue("");
                                    setError("");
                                }}

                            >
                                {constraintTypeList.map((constraint) => (
                                    <MenuItem key={constraint} value={constraint}>
                                        {constraint}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size={3}>
                        <TextField
                            fullWidth
                            sx={{ mt: 2 }}
                            type={constraintType === "=" ? "text" : "number"}   // 👈 dynamic type
                            id="outlined-controlled"
                            label="Constraint value"
                            value={constraintValue}
                            onChange={handleConstraintValueChange}
                            error={!!error}
                            helperText={error}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={4} sx={{ mb: 3 }}>
                    <Grid size={4}>
                        <TextField
                            fullWidth
                            sx={{ mt: 2 }}
                            id="outlined-controlled"
                            label="Boundary condition variable"
                            value={boundaryCondition}
                        />
                    </Grid>
                    <Grid size={4}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="problem-formulation">
                                Boundary constraint type
                            </InputLabel>
                            <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                value={boundaryconstraintType}
                                label="Select Surrogate for constraint"
                                onChange={(e) => {
                                    setBoundaryConstraintType(e.target.value);
                                    setBoundaryConstraintValue(""); // reset when type changes
                                    setBoundaryError("");
                                }}
                            >
                                {constraintTypes.map((constraint) => (
                                    <MenuItem key={constraint} value={constraint}>
                                        {constraint}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size={4}>
                        <TextField
                            fullWidth
                            sx={{ mt: 2 }}
                            type={boundaryconstraintType === "=" ? "text" : "number"}  // 👈 dynamic type
                            id="outlined-controlled"
                            label="Boundary condition constraint value"
                            value={boundaryConstraintValue}
                            onChange={handleBoundaryConstraintValueChange}
                            error={!!boundaryError}
                            helperText={boundaryError}
                        />
                    </Grid>


                </Grid>
            </Card>
            {/* <Card variant="outlined" sx={cardStyle}>
                <Grid container spacing={4} sx={{ mb: 3 }}>
                    <Grid size={4}>
                        <TextField
                            fullWidth
                            sx={{ mt: 2 }}
                            id="outlined-controlled"
                            label="Boundary condition variable"
                            value={boundaryCondition}
                        />
                    </Grid>
                    <Grid size={4}>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="problem-formulation">
                                Boundary constraint type
                            </InputLabel>
                            <Select
                                labelId="problem-formulation"
                                id="demo-simple-select"
                                value={boundaryconstraintType}
                                label="Select Surrogate for constraint"
                                onChange={(e) => {
                                    setBoundaryConstraintType(e.target.value)
                                }}
                            >
                                {constraintTypeList.map((constraint) => (
                                    <MenuItem key={constraint} value={constraint}>
                                        {constraint}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            fullWidth
                            sx={{ mt: 2 }}
                            type="number"
                            id="outlined-controlled"
                            label="Boundary condition constraint value (greater than)"
                            value={boundaryConstraintValue}
                            onChange={e => setBoundaryConstraintValue(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </Card> */}
            <Card variant="outlined" sx={cardStyle}>
                <Typography
                    variant="p"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                    }}
                >
                    Geometry input constraints:
                </Typography>

                <Grid container sx={{ mb: 3, marginTop: "10px" }}>
                    <Grid size={12}>
                        <TableContainer component={Paper}>
                            <Table sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            key="Input Variable"
                                            align="center"
                                            sx={{
                                                border: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: 'bold',
                                                padding: '6px'
                                            }}
                                        >
                                            Input variable
                                        </TableCell>
                                        <TableCell
                                            key="Constraint Type"
                                            align="center"
                                            sx={{
                                                border: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: 'bold',
                                                padding: '6px'
                                            }}
                                        >
                                            Constraint type
                                        </TableCell>
                                        <TableCell
                                            key="Value/Range"
                                            align="center"
                                            sx={{
                                                border: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: 'bold',
                                                padding: '6px'
                                            }}
                                        >
                                            Value/Range
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{
                                                border: '1px solid rgba(224, 224, 224, 1)',
                                                fontWeight: 'bold',
                                                padding: '6px'
                                            }}
                                        >
                                            Actions
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.keys(geometryInputConstraints).map((row, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            <TableCell
                                                key={`Input` + rowIndex}
                                                align="center"
                                                sx={{
                                                    border: '1px solid rgba(224, 224, 224, 1)',
                                                    padding: '8px'
                                                }}
                                            >
                                                {geometryInputs.includes(row) ? row : <TextField
                                                    id="filled-password-input"
                                                    variant="standard"
                                                    onChange={(e) => {
                                                        handleGeometryInputConstraintKey(rowIndex, e.target.value)
                                                    }}
                                                />}
                                            </TableCell>
                                            <TableCell
                                                key={`ConstraintType` + row}
                                                align="center"
                                                sx={{
                                                    border: "1px solid rgba(224, 224, 224, 1)",
                                                    padding: "8px",
                                                }}
                                            >
                                                <Select
                                                    labelId="problem-formulation"
                                                    id="demo-simple-select"
                                                    value={geometryInputConstraints[row]?.type || "None"}
                                                    label="Select Surrogate for constraint"
                                                    onChange={(e) =>
                                                        handleGeometryInputConstraintType(row, e.target.value)
                                                    }
                                                >
                                                    {geometryconstraintTypes.map((constraint) => (
                                                        <MenuItem key={constraint} value={constraint}>
                                                            {constraint}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </TableCell>
                                            <TableCell
                                                key={row}
                                                align="center"
                                                sx={{
                                                    border: "1px solid rgba(224, 224, 224, 1)",
                                                    padding: "8px",
                                                }}
                                            >
                                                <TextField
                                                    id={`constraint-value-${row}`}
                                                    variant="standard"
                                                    value={geometryInputConstraints[row].value}
                                                    error={Boolean(errors[row])}
                                                    helperText={errors[row]}
                                                    onChange={(e) => handleGeometryInputConstraintValue(row, e.target.value)}
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <IconButton
                                                    onClick={() => deleteRow(row)}
                                                    color="#837e7e"
                                                    aria-label="delete row"
                                                    sx={{ padding: "0px" }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Card>
            {geometryInputs.length > 0 && <Card variant="outlined" sx={cardStyle}>
                <Grid size={12}>
                    <Button disabled={!Object.values(errors).every(value => value === "")} onClick={processConstraints} fullWidth sx={buttonStyle} variant="contained">Process Constraints</Button>
                </Grid>
            </Card>}
            {geometryInputs.length > 0 && <Card variant="outlined" sx={cardStyle}>
                <Grid size={12}>
                    <Typography
                        variant="h8"
                        gutterBottom
                        sx={{
                            fontWeight: "bold",
                            color: "rgb(27 37 75)",
                            fontFamily: "DM Sans, sans-serif",
                        }}
                    >
                        Process constraints:
                    </Typography>
                    {Object.values(geometryInputProcessConstraints).map((constraint) => (
                        <Grid size={12}>
                            {constraint}
                        </Grid>
                    ))}
                </Grid>

            </Card>}
            <Card variant="outlined" sx={cardStyle}>
                <Grid container sx={{ mb: 3 }}>
                    <Grid size={12}>
                        <Button disabled={!checkOptimizationButton} onClick={runOptimization} fullWidth sx={buttonStyle} variant="contained">Run OPtimization</Button>
                    </Grid>
                </Grid>
            </Card>
            {optimizationTable && (
                <>
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                            fontWeight: "bold",
                            color: "rgb(27 37 75)",
                            fontFamily: "DM Sans, sans-serif",
                            marginTop: "15px"
                        }}
                    >
                        Result:
                    </Typography>

                    <Card variant="outlined" sx={[cardStyle, {width:"90vw"}]}>
                        <Typography
                            variant="h8"
                            gutterBottom
                            sx={{
                                fontWeight: "bold",
                                color: "rgb(27 37 75)",
                                fontFamily: "DM Sans, sans-serif",
                            }}
                        >
                            Best solution
                        </Typography>
                        <Grid sx={{ marginTop: "10px" }}>
                            {solutionTable()}
                        </Grid>
                    </Card>
                </>




            )}




            {optImg1plotData && optImg2plotData && figHistogram && (<Card variant="outlined" sx={cardStyle}>
                <Grid container spacing={2} sx={{ mb: 5 }}>

                    {optImg1plotData && (
                        <Grid item size={6}>
                            <Plot
                                data={optImg1plotData?.data}
                                layout={optImg1plotData?.layout}
                                // config={{ responsive: true }}
                                style={{ width: '100%', height: '100%' }}
                            />
                        </Grid>
                    )}

                    {optImg2plotData && (
                        <Grid item size={6}>
                            <Plot
                                data={optImg2plotData?.data}
                                layout={optImg2plotData?.layout}
                                // config={{ responsive: true }}
                                style={{ width: '100%', height: '100%' }}
                            />
                        </Grid>
                    )}



                </Grid>

                {figHistogram && (
                    <Grid container sx={{ mb: 3 }}>
                        <Grid item size={12}>
                            <Plot
                                data={figHistogram?.data}
                                layout={figHistogram?.layout}
                                // config={{ responsive: true }}
                                style={{ width: '100%', height: '100%' }}
                            />
                        </Grid>
                    </Grid>
                )}

            </Card>)}

            {optimizationStatus && <Card variant="outlined" sx={cardStyle}>
                <Typography
                    variant="p"
                    sx={{
                        fontWeight: "600",
                        color: "rgb(27 37 75)",
                        fontFamily: "DM Sans, sans-serif",
                        fontSize: '1.2rem'
                    }}
                >
                    {optimizationStatus}
                </Typography>
            </Card>}


            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loadopen}
            >
                <CircularProgress size="4rem" />
            </Backdrop>

            <CustomizedSnackbar action={snackbarOpen} message={snackbarMsg} severityType={severityType} />
        </>
    )
}
